import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const ChargeStateXrefSchema = z
    .object({
        id: z.number().optional(),
        chargeId: z.number(),
        state: z.string(),
        feeDescId: z.number(),
        isExpired: z.boolean().optional(),
    });

export type ChargeStateXref = z.infer<typeof ChargeStateXrefSchema>;

export const all = async (
    pagination: PaginationState,
    sorting: SortingState = [],
    params: object,
): Promise<{ data: ChargeStateXref[]; total: number }> => {
    try {
        let queryString = '';
        if (params) {
            const paramsAsString = JSON.stringify(params)
                .replace(/:/g, '=')
                .replace(/,/g, '&')
                .replace(/[{}"]/g, '');

            const searchParams = new URLSearchParams(paramsAsString);
            if (pagination) {
                searchParams.append('pageSize', pagination.pageSize.toString());
                searchParams.append('pageIndex', pagination.pageIndex.toString());
            }

            if (sorting.length > 0) {
                searchParams.append('sortBy', sorting[0].id);
                searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
            }

            queryString = `?${searchParams.toString()}`;
        }

        const response = await fetch(`/ChargeStateXref${queryString}`);

        return await response.json();
    } catch (err) {
        return {
            data: [],
            total: 0,
        };
    }
};

export const add = async (charge: ChargeStateXref): Promise<boolean> => {
    const res = await fetch(`/ChargeStateXref`, {
        method: 'POST',
        body: JSON.stringify(charge),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};

export const update = async (
    charge: ChargeStateXref,
): Promise<boolean> => {
    const res = await fetch(`/ChargeStateXref`, {
        method: 'PATCH',
        body: JSON.stringify(charge),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};
